<template>
  <!-- begin:: Aside -->
  <div>
    <button class="kt-aside-close" id="kt_aside_close_btn" @click="sendMessage">
      <i class="la la-close"></i>
    </button>
    <div
      class="
        kt-aside kt-aside--fixed
        kt-grid__item
        kt-grid kt-grid--desktop kt-grid--hor-desktop
      "
      id="kt_aside"
    >
      <!-- begin:: Aside Menu -->

      <VuePerfectScrollbar
        class="
          kt-aside-menu-wrapper
          kt-grid__item kt-grid__item--fluid
          scroll-area
        "
        :settings="psSettings"
        @ps-scroll-y="scrollHandle"
        id="kt_aside_menu_wrapper"
      >
        <div id="kt_aside_menu" class="kt-aside-menu">
          <ul class="kt-menu__nav">
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchConfiguration }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
            >
              <a
                @click="toggleSubmenu($event, 'switchConfiguration')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon flaticon-cogwheel"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Configuration")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu configuration"
                :class="{ expanded: switchConfiguration }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in configuration"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchProducts }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
            >
              <a
                @click="toggleSubmenu($event, 'switchProducts')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon flaticon-presentation-1"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Products")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu products"
                :class="{ expanded: switchProducts }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in products"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchPlatformReports }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
            >
              <a
                @click="toggleSubmenu($event, 'switchPlatformReports')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon flaticon-pie-chart"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Platform Reports")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu platformReports"
                :class="{ expanded: switchPlatformReports }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in platformReports"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchReports }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
            >
              <a
                @click="toggleSubmenu($event, 'switchReports')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon flaticon-time-1"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Reports")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu reports"
                :class="{ expanded: switchReports }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in reports"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchFinancialReports }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
            >
              <a
                @click="toggleSubmenu($event, 'switchFinancialReports')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon flaticon-diagram"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Financial Reports")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu financialReports"
                :class="{ expanded: switchFinancialReports }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in financialReports"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchJackpots }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
            >
              <a
                @click="toggleSubmenu($event, 'switchJackpots')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon icon-diamond"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Jackpots")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu financialReports"
                :class="{ expanded: switchJackpots }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in jackpots"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
            <li
              class="kt-menu__item kt-menu__item--submenu"
              :class="{ 'kt-menu__item--open': switchAdmin }"
              aria-haspopup="true"
              data-ktmenu-submenu-toggle="hover"
              v-if="admin.length"
            >
              <a
                @click="toggleSubmenu($event, 'switchAdmin')"
                class="kt-menu__link kt-menu__toggle"
              >
                <i class="kt-menu__link-icon flaticon-cogwheel-1"></i>
                <span class="kt-menu__link-text font-weight-bold">{{
                  $t("Administration")
                }}</span>
                <i class="kt-menu__ver-arrow la la-angle-right"></i>
              </a>
              <div
                class="kt-menu__submenu admin"
                :class="{ expanded: switchAdmin }"
              >
                <span class="kt-menu__arrow"></span>
                <ul class="kt-menu__subnav">
                  <li
                    v-for="(item, index) in admin"
                    v-bind:key="index"
                    class="kt-menu__item"
                    aria-haspopup="true"
                  >
                    <router-link :to="item.url" class="kt-menu__link pl-50px">
                      <span class="kt-menu__link-text">
                        <i class="iicon mr-10px" :class="item.icon"></i>
                        <span class="text">{{ $t(item.name) }}</span>
                      </span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </VuePerfectScrollbar>
      <!-- end:: Aside Menu -->
    </div>
    <!-- end:: Aside -->
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import KTUtil from "@/shared/kutils";
import idToRole from "@/store/ui-permissions/routerPermissions";

export default {
  props: ["items"],
  components: {
    VuePerfectScrollbar,
  },
  computed: {
    psSettings: () => {
      // ToDo: find better rtl fix
      return {
        maxScrollbarLength: 200,
        minScrollbarLength: 40,
        suppressScrollX:
          getComputedStyle(document.querySelector("html")).direction !== "rtl",
        wheelPropagation: false,
        interceptRailY: (styles) => ({ ...styles, height: 0 }),
      };
    },
  },
  watch: {
    $route(to, from) {
      if (to && to.path) {
        this.configuration.forEach((elem) => {
          if (elem.url === to.path) {
            this.switchConfiguration = true;
            return;
          }
        });
        this.products.forEach((elem) => {
          if (elem.url === to.path) {
            this.switchProducts = true;
            return;
          }
        });
        this.reports.forEach((elem) => {
          if (elem.url === to.path) {
            this.switchReports = true;
            return;
          }
        });
        this.platformReports.forEach((elem) => {
          if (elem.url === to.path) {
            this.switchPlatformProducts = true;
            return;
          }
        });
        this.admin.forEach((elem) => {
          if (elem.url === to.path) {
            this.switchAdmin = true;
            return;
          }
        });
      }
    },
  },
  data() {
    return {
      i: 0,
      switchConfiguration: false,
      switchProducts: false,
      switchReports: false,
      switchPlatformReports: false,
      switchFinancialReports: false,
      switchJackpots: false,
      switchAdmin: false,
      configuration: [],
      products: [],
      reports: [],
      platformReports: [],
      financialReports: [],
      jackpots: [],
      admin: [],
      links: [],
    };
  },
  methods: {
    toggleSubmenu(ev, type) {
      const val = this[type];
      //this.switchConfiguration = false;
      //this.switchProducts = false;
      //this.switchReports = false;
      this[type] = !val;
    },
    scrollHandle(evt) {
      // console.log(evt)
    },
    sendMessage() {
      this.$emit("close", "kt_aside_close_btn_" + this.i);
      this.i++;
    },
  },
  mounted() {
    const self = this;
    const items = this.items;

    const path = this.$route.path;

    items.forEach((element) => {
      if (element.id == "home") return;
      const tmp = JSON.parse(JSON.stringify(element));

      if (typeof element.children != "undefined") {
        element.children.forEach((el) => {
          const tmp = JSON.parse(JSON.stringify(el));
          if (typeof idToRole[tmp.id] != "undefined") {
            const role = idToRole[tmp.id];
            if (!role.ignore) {
              if (!this.$ability.can(role.action, role.subject)) {
                return;
              }
            }
            self[tmp.category].push(tmp);
            self.links.push(tmp);

            if (tmp.url === path) {
              switch (tmp.category) {
                case "configuration":
                  self.switchConfiguration = true;
                  break;
                case "products":
                  self.switchProducts = true;
                  break;
                case "reports":
                  self.switchReports = true;
                  break;
                case "platformReports":
                  self.switchPlatformReports = true;
                  break;
                case "financialReports":
                  self.switchFinancialReports = true;
                  break;
                case "jackpots":
                  self.switchJackpots = true;
                  break;
                case "admin":
                  self.switchAdmin = true;
                  break;
                default:
                // noop
              }
            }
          }
        });
      } else {
        if (typeof idToRole[tmp.id] != "undefined") {
          const role = idToRole[tmp.id];
          if (!role.ignore) {
            if (!this.$ability.can(role.action, role.subject)) {
              return;
            }
          }
          self[tmp.category].push(tmp);
          self.links.push(tmp);
          if (tmp.url === path) {
            switch (tmp.category) {
              case "configuration":
                self.switchConfiguration = true;
                break;
              case "products":
                self.switchProducts = true;
                break;
              case "reports":
                self.switchReports = true;
                break;
              case "platformReports":
                self.switchPlatformReports = true;
                break;
              case "financialReports":
                self.switchFinancialReports = true;
                break;
              case "jackpots":
                self.switchJackpots = true;
                break;
              case "admin":
                self.switchAdmin = true;
                break;
              default:
              // noop
            }
          }
        }
      }
    });

    const body = KTUtil.get("body");
    const aside = KTUtil.get("kt_aside");

    var insideTm;
    var outsideTm;

    KTUtil.addEvent(aside, "mouseenter", function (e) {
      e.preventDefault();

      if (KTUtil.isInResponsiveRange("desktop") === false) {
        return;
      }

      if (outsideTm) {
        clearTimeout(outsideTm);
        outsideTm = null;
      }

      insideTm = setTimeout(function () {
        if (
          KTUtil.hasClass(body, "kt-aside--minimize") &&
          KTUtil.isInResponsiveRange("desktop")
        ) {
          KTUtil.removeClass(body, "kt-aside--minimize");

          // Minimizing class
          KTUtil.addClass(body, "kt-aside--minimizing");
          KTUtil.transitionEnd(body, function () {
            KTUtil.removeClass(body, "kt-aside--minimizing");
          });

          // Hover class
          KTUtil.addClass(body, "kt-aside--minimize-hover");
        }
      }, 50);
    });

    KTUtil.addEvent(aside, "mouseleave", function (e) {
      e.preventDefault();

      if (KTUtil.isInResponsiveRange("desktop") === false) {
        return;
      }

      if (insideTm) {
        clearTimeout(insideTm);
        insideTm = null;
      }

      outsideTm = setTimeout(function () {
        if (
          KTUtil.hasClass(body, "kt-aside--minimize-hover") &&
          KTUtil.isInResponsiveRange("desktop")
        ) {
          KTUtil.removeClass(body, "kt-aside--minimize-hover");
          KTUtil.addClass(body, "kt-aside--minimize");

          // Minimizing class
          KTUtil.addClass(body, "kt-aside--minimizing");
          KTUtil.transitionEnd(body, function () {
            KTUtil.removeClass(body, "kt-aside--minimizing");
          });
        }
      }, 100);
    });
  },
};
</script>

<style lang="scss" scoped>
.scroll-area {
  height: 100%;
}
.kt-menu__link-text {
  white-space: nowrap;
}

.kt-menu__submenu {
  display: block !important;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.15s linear;
}
.kt-menu__submenu.configuration.expanded {
  max-height: 560px;
}
.kt-menu__submenu.products.expanded {
  max-height: 280px;
}
.kt-menu__submenu.platformReports.expanded {
  max-height: 160px;
}
.kt-menu__submenu.reports.expanded {
  max-height: 320px;
}
.kt-menu__submenu.financialReports.expanded {
  max-height: 560px;
}
.kt-menu__submenu.admin.expanded {
  max-height: 40px;
}
</style>
